import { post } from '@/helpers/api'
import store, {
	setUser,
	getMyUserId,
	setChats,
	setMembershipsSafe,
} from '@/store'
import * as rest from '@/api/rest'

export const fetchMyUserInfo = async (hasActivity = false) => {
	try {
		const data = await fetchUserInfo(getMyUserId(), hasActivity)
		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const fetchUserInfo = async (user_id, hasActivity) => {
	try {
		const { data } = await post('/api/v1/user.info', { id: user_id })
		if (hasActivity) {
			data.user.hasactivity = true
		}
		setUser(data.user)

		if (user_id === getMyUserId()) {
			store.auth.setUser(data.user, store.userKey)
		}

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const searchUsers = async (query, options = {}, config = {}) => {
	try {
		const params = {
			'page[size]': 30,
			'filter[query]': query,
			...options,
		}
		const data = await rest.get('users/search', params, config)
		return data
	} catch (error) {
		if (config?.signal?.aborted) return null
		console.error(error, config)
		return { data: [], error }
	}
}

export const updateUser = async (payload) => {
	const { data } = await post('/api/v1/user.update', payload)
	if (data.ok === false) throw new Error(data.error)
	setUser(data.user)
	return data.user
}

export const updateClientMeta = async (client_meta) => {
	const user_id = getMyUserId()
	return updateUser({ user_id, client_meta })
}

// Provisions the authenticated user's SVIX webhook application. Idempotent
// server-side; may 400 WEBHOOKS_EMAIL_REQUIRED.
export const provisionWebhooks = async () => {
	await rest.post('/users/me/webhooks_application')
}

// Mints a short-lived, single-use SVIX portal session URL. Request at embed time,
// never cache. `darkMode` is one of 'true' | 'false' | 'auto' to match the app theme.
// Throws a 404 when the user's webhook application has not been provisioned yet —
// callers use that to distinguish "not enabled" from a real error.
export const createWebhookPortalSession = async (darkMode) => {
	const { url } = await rest.post('/users/me/webhooks_portal', {
		dark_mode: darkMode,
	})
	return url
}

export const fetchMembershipCounts = async (userId) => {
	const { data } = await rest.get(`/users/${userId}/memberships/counts`)
	return data
}

export const fetchMutualGroups = async (user_id) => {
	const { data } = await post('/api/v1/user.mutualgroups', { user_id })
	setChats(data.bubbles)
	setMembershipsSafe(data.memberships)
	return data
}
